import {
  ActionType,
  IMiniStressLastNotificationTimeResponse,
} from "models/stressCheck/miniStressLastNotificationTime";

export const getMiniStressLastNotificationTimeAction = () => {
  return {
    type: ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: IMiniStressLastNotificationTimeResponse
) => {
  return {
    type: ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME_RESET,
  };
};
